import React from 'react'
import { ButtonRounded, Modal } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import styles from './DraftReuseModal.module.css'

type DraftReuseModalProps = {
  isOpen: boolean
  isLoading: boolean
  onClose: () => void
  onConfirm: () => void
  onDecline: () => void
}

export function DraftReuseModal({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
  onDecline,
}: DraftReuseModalProps): React.JSX.Element {
  const { t } = useTranslation()

  if (!isOpen) {
    return <></>
  }

  return (
    <Modal.Root isOpen={isOpen} onClose={onClose}>
      <Modal.Backdrop>
        <Modal.Surface width={560} data-testid='draft-reuse-modal'>
          <Modal.Header>
            <Modal.TitleGroup>
              <Modal.Title>{t('objectChooser.reuseModal.title')}</Modal.Title>
            </Modal.TitleGroup>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <div className={styles.content}>
              <p className='font-body-medium-regular margin-bottom-l'>{t('objectChooser.reuseModal.description')}</p>
              <div className={styles.actions}>
                <ButtonRounded
                  variant='filledDefault'
                  onClick={onConfirm}
                  disabled={isLoading}
                  data-testid='draft-reuse-confirm'
                >
                  {t('objectChooser.reuseModal.primaryAction')}
                </ButtonRounded>
                <ButtonRounded
                  variant='textDefault'
                  onClick={onDecline}
                  disabled={isLoading}
                  data-testid='draft-reuse-decline'
                >
                  {t('objectChooser.reuseModal.secondaryAction')}
                </ButtonRounded>
              </div>
            </div>
          </Modal.Body>
        </Modal.Surface>
      </Modal.Backdrop>
    </Modal.Root>
  )
}
